import React, {createContext, Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import UserStore from "./store/UserStore";
import AddStore from "./store/AddStore";
import FilterStore from './store/FilterStore';
import HelperStore from "./store/HelperStore";
import ChatStore from "./store/ChatStore";
import {SocketProvider} from "./store/SocketContext";
import Loading from "./components/commons/Loading/Loading";

export const Context = createContext(null)

ReactDOM.render(
    <Suspense fallback={<Loading />}>
        <Context.Provider value={{
            user: new UserStore(),
            add: new AddStore(),
            filter: new FilterStore(),
            helper: new HelperStore(),
            chat: new ChatStore()
        }}>
            <SocketProvider>
                <App/>
            </SocketProvider>
        </Context.Provider>
    </Suspense>,
    document.getElementById('root')
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(reg => {
                console.log('✅ Service Worker зарегистрирован:', reg);
            })
            .catch(err => {
                console.error('❌ Ошибка регистрации Service Worker:', err);
            });
    });
}
